import bicepsBrachiiIcon from '@assets/images/muscle-icons/biceps-brachii.png'
import brachialisIcon from '@assets/images/muscle-icons/brachialis.png'
import brachioradialisIcon from '@assets/images/muscle-icons/brachioradialis.png'
import calvesIcon from '@assets/images/muscle-icons/calves.png'
import deltoidIcon from '@assets/images/muscle-icons/deltoid.png'
import deltoidAnteriorIcon from '@assets/images/muscle-icons/deltoid-anterior.png'
import deltoidPosteriorIcon from '@assets/images/muscle-icons/deltoid-posterior.png'
import erectorSpinaeBackIcon from '@assets/images/muscle-icons/erector-spinae-back.png'
import erectorSpinaeCoreIcon from '@assets/images/muscle-icons/erector-spinae-core.png'
import forearmMusclesIcon from '@assets/images/muscle-icons/forearm-muscles.png'
import gastrocnemiusIcon from '@assets/images/muscle-icons/gastrocnemius.png'
import glutesIcon from '@assets/images/muscle-icons/glutes.png'
import hamstringsIcon from '@assets/images/muscle-icons/hamstrings.png'
import iliopsoasCoreIcon from '@assets/images/muscle-icons/iliopsoas-core.png'
import iliopsoasLegsIcon from '@assets/images/muscle-icons/iliopsoas-legs.png'
import innerChestIcon from '@assets/images/muscle-icons/inner-chest.png'
import latissimusDorsiIcon from '@assets/images/muscle-icons/latissimus-dorsi.png'
import lowerBackMusclesIcon from '@assets/images/muscle-icons/lower-back-muscles.png'
import lowerTrapeziusIcon from '@assets/images/muscle-icons/lower-trapezius.png'
import obliquesIcon from '@assets/images/muscle-icons/obliques.png'
import pectoralisMajorIcon from '@assets/images/muscle-icons/pectoralis-major.png'
import quadricepsIcon from '@assets/images/muscle-icons/quadriceps.png'
import rectusAbdominisIcon from '@assets/images/muscle-icons/rectus-abdominis.png'
import rhomboidsIcon from '@assets/images/muscle-icons/rhomboids.png'
import soleusIcon from '@assets/images/muscle-icons/soleus.png'
import transversusAbdominisIcon from '@assets/images/muscle-icons/transversus-abdominis.png'
import trapeziusIcon from '@assets/images/muscle-icons/trapezius.png'
import tricepsBrachiiIcon from '@assets/images/muscle-icons/triceps-brachii.png'
import upperChestIcon from '@assets/images/muscle-icons/upper-chest.png'
import upperTrapeziusIcon from '@assets/images/muscle-icons/upper-trapezius.png'

export type FilterMuscleItem = {
	code: string
	title: string
	icon: string
}

export type FilterMuscleSection = {
	title: string
	items: FilterMuscleItem[]
}

export type FilterGroupChip = {
	label: string
	codes: string[]
}

export const FILTER_MUSCLE_SECTIONS: FilterMuscleSection[] = [
	{
		title: 'Грудь',
		items: [
			{
				code: 'upper_chest',
				title: 'Верхняя часть грудных мышц',
				icon: upperChestIcon,
			},
			{
				code: 'inner_chest',
				title: 'Внутренняя часть грудных мышц',
				icon: innerChestIcon,
			},
			{
				code: 'pectoralis_major',
				title: 'Грудные мышцы (общее)',
				icon: pectoralisMajorIcon,
			},
		],
	},
	{
		title: 'Кор',
		items: [
			{ code: 'obliques', title: 'Косые мышцы живота', icon: obliquesIcon },
			{
				code: 'transversus_abdominis',
				title: 'Поперечная мышца живота',
				icon: transversusAbdominisIcon,
			},
			{
				code: 'rectus_abdominis',
				title: 'Прямая мышца живота',
				icon: rectusAbdominisIcon,
			},
			{
				code: 'erector_spinae_core',
				title: 'Разгибатели спины',
				icon: erectorSpinaeCoreIcon,
			},
			{
				code: 'iliopsoas_core',
				title: 'Подвздошно-поясничная мышца',
				icon: iliopsoasCoreIcon,
			},
		],
	},
	{
		title: 'Ноги',
		items: [
			{ code: 'hamstrings', title: 'Бицепсы бедра', icon: hamstringsIcon },
			{ code: 'quadriceps', title: 'Квадрицепсы', icon: quadricepsIcon },
			{ code: 'calves', title: 'Мышцы голени (общее)', icon: calvesIcon },
			{
				code: 'iliopsoas_legs',
				title: 'Подвздошно-поясничная мышца',
				icon: iliopsoasLegsIcon,
			},
			{
				code: 'gastrocnemius',
				title: 'Икроножные мышцы',
				icon: gastrocnemiusIcon,
			},
			{ code: 'soleus', title: 'Камбаловидная мышца', icon: soleusIcon },
			{ code: 'glutes', title: 'Ягодичные мышцы', icon: glutesIcon },
		],
	},
	{
		title: 'Плечи',
		items: [
			{
				code: 'deltoid',
				title: 'Дельтовидные мышцы (все три пучка)',
				icon: deltoidIcon,
			},
			{
				code: 'deltoid_posterior',
				title: 'Задние дельтовидные мышцы',
				icon: deltoidPosteriorIcon,
			},
			{
				code: 'deltoid_anterior',
				title: 'Передние дельтовидные мышцы',
				icon: deltoidAnteriorIcon,
			},
		],
	},
	{
		title: 'Руки',
		items: [
			{ code: 'biceps_brachii', title: 'Бицепсы', icon: bicepsBrachiiIcon },
			{
				code: 'brachialis',
				title: 'Плечевая мышца (brachialis)',
				icon: brachialisIcon,
			},
			{
				code: 'brachioradialis',
				title: 'Плечелучевая мышца',
				icon: brachioradialisIcon,
			},
			{
				code: 'forearm_muscles',
				title: 'Мышца предплечья',
				icon: forearmMusclesIcon,
			},
			{ code: 'triceps_brachii', title: 'Трицепсы', icon: tricepsBrachiiIcon },
		],
	},
	{
		title: 'Спина',
		items: [
			{
				code: 'upper_trapezius',
				title: 'Верхняя часть трапеций',
				icon: upperTrapeziusIcon,
			},
			{
				code: 'lower_trapezius',
				title: 'Нижняя часть трапеций',
				icon: lowerTrapeziusIcon,
			},
			{
				code: 'erector_spinae',
				title: 'Разгибатели спины',
				icon: erectorSpinaeBackIcon,
			},
			{
				code: 'trapezius',
				title: 'Трапеции (общее)',
				icon: trapeziusIcon,
			},
			{
				code: 'latissimus_dorsi',
				title: 'Широчайшие мышцы спины',
				icon: latissimusDorsiIcon,
			},
			{
				code: 'lower_back_muscles',
				title: 'Мышцы нижней части спины',
				icon: lowerBackMusclesIcon,
			},
			{ code: 'rhomboids', title: 'Ромбовидные мышцы', icon: rhomboidsIcon },
		],
	},
]

export const ALL_FILTER_MUSCLE_CODES = FILTER_MUSCLE_SECTIONS.flatMap((section) =>
	section.items.map((item) => item.code),
)

const getSectionCodes = (sectionTitle: string): string[] =>
	FILTER_MUSCLE_SECTIONS.find((section) => section.title === sectionTitle)?.items.map(
		(item) => item.code,
	) ?? []

export const FILTER_GROUP_CHIPS: FilterGroupChip[] = [
	{ label: 'Full Body', codes: ALL_FILTER_MUSCLE_CODES },
	{
		label: 'Верх тела',
		codes: [
			...getSectionCodes('Грудь'),
			...getSectionCodes('Плечи'),
			...getSectionCodes('Руки'),
			...getSectionCodes('Спина'),
		],
	},
	{ label: 'Спина', codes: getSectionCodes('Спина') },
	{ label: 'Ноги', codes: getSectionCodes('Ноги') },
	{ label: 'Пресс', codes: getSectionCodes('Кор') },
]
